/**
 * Action Types
 */

export const Types = {
    IS_CONNECTED: 'websocket/IS_CONNECTED'
};

/**
 * Reducer
 */

const INITIAL_STATE = true;

export default function websocketConnection(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.IS_CONNECTED:
            return action.payload;

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    connectWebsocket: (payload) => ({
        type: Types.IS_CONNECTED,
        payload
    })
};
